import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  icon: {
    flexShrink: 0
  },
  image: {
    borderRadius: '8px',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    cursor: 'pointer',
    objectFit: 'cover'
  }
}))

export default useStyles
